// @mui
import { arSA, bgBG,csCZ, daDK, deDE, heIL,huHU, esES, enUS, frFR, itIT, jaJP, nlNL, plPL, ptPT, ptBR, koKR, srRS, svSE, zhCN,fiFI,zhTW, etEE,nbNO,ruRU, hrHR,trTR,roRO,thTH,skSK,elGR} from '@mui/material/locale';
import kaGE from './langs/ka-GE';
import de from './langs/de';
import enPH from './langs/en-PH';
import enSG from './langs/en-SG';
import zhSG from './langs/zh-SG';
import bnIN from './langs/bn-IN';
import mlIN from './langs/ml-IN';
import orIN from './langs/or-IN';
import paIN from './langs/pa-IN';
import urIN from './langs/ur-IN';
import stZA from './langs/st-ZA';
import nsoZA from './langs/nso-ZA';
import tnZA from './langs/tn-ZA';
// import cs from './langs/cs';

interface TablePaginationParams {
  from: number;
  to: number;
  count: number;
}

const af = { components: {} };
const xh = { components: {} };
const zh = { components: {} };
const zu = { components: {} };

export const allLangs = [
  {
  label: 'Afrikaans (South Africa)',
  value: 'af-ZA',
  systemValue: af,
  icon: '',
},
{
  label: 'Arabic (Israel)',
  value: 'ar-IL',
  systemValue: arSA,
  icon: '',
},
{
  label: 'Bulgarian (Bulgaria)',
  value: 'bg-BG',
  systemValue: bgBG,
  icon: '',
},
{
  label: 'Bengali (India)',
  value: 'bn-IN',
  systemValue: bnIN,
  icon: '',
},
{
  label: 'Chinese (China)',
  value: 'zh-CN',
  systemValue: zhCN,
  icon: '',
},
// {
//   label: 'Chinese (Singapore)',
//   value: 'zh-SG',
//   systemValue: zhSG,
//   icon: '',
// },
{
  label: 'Chinese (Taiwan)',
  value: 'zh-TW',
  systemValue: zhTW,
  icon: '',
},
{
  label: 'Croatian (Croatia)',
  value: 'hr-HR',
  systemValue: hrHR,
  icon: '',
},
{
  label: 'Czech (Czech Republic)',
  value: 'cs-CZ',
  systemValue: csCZ,
  icon: '',
},
{
  label: 'Danish (Denmark)',
  value: 'da-DK',
  systemValue: daDK,
  icon: '',
},
{
  label: 'Dutch (Belgium)',
  value: 'nl-BE',
  systemValue: nlNL,
  icon: '',
},
{
  label: 'Dutch (Netherlands)',
  value: 'nl-NL',
  systemValue: nlNL,
  icon: '',
},
{
  label: 'English (Australia)',
  value: 'en-AU',
  systemValue: enUS,
  icon: '',
},
{
  label: 'English (Canada)',
  value: 'en-CA',
  systemValue: enUS,
  icon: '',
},
{
  label: 'English (India)',
  value: 'en-IN',
  systemValue: enUS,
  icon: '',
},
{
  label: 'English (Ireland)',
  value: 'en-IE',
  systemValue: enUS,
  icon: '',
},
{
  label: 'English (New Zealand)',
  value: 'en-NZ',
  systemValue: enUS,
  icon: '',
},
{
  label: 'English (Philippines)',
  value: 'en-PH',
  systemValue: enPH,
  icon: '',
},
// {
//   label: 'English (Singapore)',
//   value: 'en-SG',
//   systemValue: enSG,
//   icon: '',
// },
{
  label: 'English (South Africa)',
  value: 'en-ZA',
  systemValue: enUS,
  icon: '',
},
{
  label: 'English (United Kingdom)',
  value: 'en-GB',
  systemValue: enUS,
  icon: '',
},
{
  label: 'English (United States)',
  value: 'en-US',
  systemValue: enUS,
  icon: '',
},
{
  label: 'Estonia (Estonia)',
  value: 'et-EE',
  systemValue: etEE,
  icon: '',
},
{
  label: 'Finnish (Finland)',
  value: 'fi-FI',
  systemValue: fiFI,
  icon: '',
  },
{
  label: '',
  value: 'fil-PH',
  systemValue: enPH,
  icon: '',
},
{
  label: 'French (Belgium)',
  value: 'fr-BE',
  systemValue: frFR,
  icon: '',
},
{
  label: 'French (Canada)',
  value: 'fr-CA',
  systemValue: frFR,
  icon: '',
},
{
  label: 'French (France)',
  value: 'fr-FR',
  systemValue: itIT,
  icon: '',
},
{
  label: 'French (Switzerland)',
  value: 'fr-CH',
  systemValue: itIT,
  icon: '',
},
{
  label: 'Georgian (Georgia)',
  value: 'ka-GE',
  systemValue: kaGE,
  icon: '',
},
{
  label: 'German (Austria)',
  value: 'de-AT',
  systemValue: deDE,
  icon: '',
},
{
  label: 'German (Belgium)',
  value: 'de-BE',
  systemValue: deDE,
  icon: '',
},
{
  label: 'German (Germany)',
  value: 'de-DE',
  systemValue: deDE,
  icon: '',
},
{
  label: 'German (Switzerland)',
  value: 'de-CH',
  systemValue: deDE,
  icon: '',
},
{
  label: 'Greek (Greece)',
  value: 'el-GR',
  systemValue: elGR,
  icon: '',
},
{
  label: 'Gujarati (India)',
  value: 'gu-IN',
  systemValue: enUS,
  icon: '',
},
{
  label: 'Hebrew (Israel)',
  value: 'he-IL',
  systemValue: heIL,
  icon: '',
},
{
  label: 'Hindi (India)',
  value: 'hi-IN',
  systemValue: enUS,
  icon: '',
},
{
  label: 'Hungarian (Hungary)',
  value: 'hu-HU',
  systemValue: huHU,
  icon: '',
},
{
  label: 'Italian (Italy)',
  value: 'it-IT',
  systemValue: itIT,
  icon: '',
},
{
  label: 'Italian (Switzerland)',
  value: 'it-CH',
  systemValue: itIT,
  icon: '',
},
{
  label: 'Japanese (Japan)',
  value: 'ja-JP',
  systemValue: jaJP,
  icon: '',
},
{
  label: 'Korean (Korea)',
  value: 'ko-KR',
  systemValue: koKR,
  icon: '',
},
{
  label: 'Kannada (India)',
  value: 'kn-IN',
  systemValue: enUS,
  icon: '',
},
{
  label: 'Marathi (India)',
  value: 'mr-IN',
  systemValue: enUS,
  icon: '',
},
{
  label: 'Malayalam (India)',
  value: 'ml-IN',
  systemValue: mlIN,
  icon: '',
},
{
  label: 'Norwegian (Norway)',
  value: 'nb-NO',
  systemValue: nbNO,
  icon: '',
},
{
  label: 'Northern Sotho (South Africa)',
  value: 'nso-ZA',
  systemValue: nsoZA,
  icon: '',
},
{
  label: 'Odia (India)',
  value: 'or-IN',
  systemValue: orIN,
  icon: '',
},
{
  label: 'Punjabi (India)',
  value: 'pa-IN',
  systemValue: paIN,
  icon: '',
},
{
  label: 'Polish (Poland)',
  value: 'pl-PL',
  systemValue: plPL,
  icon: '',
},
{
  label: 'Portuguese (Brasil)',
  value: 'pt-BR',
  systemValue: ptBR,
  icon: '',
},
{
  label: 'Portuguese (Portugal)',
  value: 'pt-PT',
  systemValue: ptPT,
  icon: '',
},
{
  label: 'Romanian (Romania)',
  value: 'ro-RO',
  systemValue: roRO,
  icon: '',
},
{
  label: 'Russian (Russia)',
  value: 'ru-RU',
  systemValue: ruRU,
  icon: '',
},
{
  label: 'Serbian (Serbia)',
  value: 'sr-RS',
  systemValue: srRS,
  icon: '',
},
{
  label: 'Slovak (Slovakia)',
  value: 'sk-SK',
  systemValue: skSK,
  icon: '',
},
{
  label: 'Southern Sotho (South Africa)',
  value: 'st-ZA',
  systemValue: stZA,
  icon: '',
},
{
  label: 'Spanish (Argentina)',
  value: 'es-AR',
  systemValue: esES,
  icon: '',
},
{
  label: 'Spanish (Chile)',
  value: 'es-CL',
  systemValue: esES,
  icon: '',
},
{
  label: 'Spanish (Colombia)',
  value: 'es-CO',
  systemValue: esES,
  icon: '',
},
{
  label: 'Spanish (Mexico)',
  value: 'es-MX',
  systemValue: esES,
  icon: '',
},
{
  label: 'Spanish (Puero Rico)',
  value: 'es-PR',
  systemValue: esES,
  icon: '',
},
{
  label: 'Spanish (Spain)',
  value: 'es-ES',
  systemValue: esES,
  icon: '',
},
{
  label: 'Spanish (United States)',
  value: 'es-US',
  systemValue: esES,
  icon: '',
},
{
  label: 'Swedish (Finland)',
  value: 'sv-FI',
  systemValue: svSE,
  icon: '',
},
{
  label: 'Swedish (Sweden)',
  value: 'sv-SE',
  systemValue: svSE,
  icon: '',
},
{
  label: 'Tamil (India)',
  value: 'ta-IN',
  systemValue: enUS,
  icon: '',
},
{
  label: 'Telugu (India)',
  value: 'te-IN',
  systemValue: enUS,
  icon: '',
},
{
  label: 'Thai (Thailand)',
  value: 'th-TH',
  systemValue: thTH,
  icon: '',
},
{
  label: 'Tswana (South Africa)',
  value: 'tn-ZA',
  systemValue: tnZA,
  icon: '',
},
{
  label: 'Turkish (Turkey)',
  value: 'tr-TR',
  systemValue: trTR,
  icon: '',
},
{
  label: 'Urdu (India)',
  value: 'ur-IN',
  systemValue: urIN,
  icon: '',
},
{
  label: 'Xhosa (South Africa)',
  value: 'xh-ZA',
  systemValue: xh,
  icon: '',
},
{
  label: 'Zulu (South Africa)',
  value: 'zu-ZA',
  systemValue: zu,
  icon: '',
},
{
  label: '',
  value: 'af',
  systemValue: af,
  icon: '',
},
{
  label: '',
  value: 'ar',
  systemValue: arSA,
  icon: '',
},
{
  label: '',
  value: 'bg',
  systemValue: bgBG,
  icon: '',
},
{
  label: '',
  value: 'cs',
  systemValue: csCZ,
  icon: '',
},
{
  label: '',
  value: 'da',
  systemValue: daDK,
  icon: '',
},
{
  label: '',
  value: 'de',
  systemValue: de,
  icon: '',
},
{
  label: '',
  value: 'el',
  systemValue: elGR,
  icon: '',
},
{
  label: '',
  value: 'en',
  systemValue: enUS,
  icon: '',
},
{
  label: '',
  value: 'es',
  systemValue: esES,
  icon: '',
},
{
  label: '',
  value: 'et',
  systemValue: etEE,
  icon: '',
},
{
  label: '',
  value: 'fi',
  systemValue: fiFI,
  icon: '',
},
{
  label: '',
  value: 'fr',
  systemValue: frFR,
  icon: '',
},
{
  label: '',
  value: 'he',
  systemValue: heIL,
  icon: '',
},
{
  label: '',
  value: 'hr',
  systemValue: hrHR,
  icon: '',
},
{
  label: '',
  value: 'hu',
  systemValue: huHU,
  icon: '',
},
{
  label: '',
  value: 'it',
  systemValue: itIT,
  icon: '',
},
{
  label: '',
  value: 'ja',
  systemValue: jaJP,
  icon: '',
},
{
  label: '',
  value: 'ka',
  systemValue: kaGE,
  icon: '',
},
{
  label: '',
  value: 'ko',
  systemValue: koKR,
  icon: '',
},
{
  label: '',
  value: 'nb',
  systemValue: nbNO,
  icon: '',
},
{
  label: '',
  value: 'nl',
  systemValue: nlNL,
  icon: '',
},
{
  label: '',
  value: 'pl',
  systemValue: plPL,
  icon: '',
},
{
  label: '',
  value: 'pt',
  systemValue: ptPT,
  icon: '',
},
{
  label: '',
  value: 'ro',
  systemValue: roRO,
  icon: '',
},
{
  label: '',
  value: 'ru',
  systemValue: ruRU,
  icon: '',
},
{
  label: '',
  value: 'sk',
  systemValue: skSK,
  icon: '',
},
{
  label: '',
  value: 'sr',
  systemValue: srRS,
  icon: '',
},
{
  label: '',
  value: 'sv',
  systemValue: svSE,
  icon: '',
},
{
  label: '',
  value: 'th',
  systemValue: thTH,
  icon: '',
},
{
  label: '',
  value: 'tr',
  systemValue: trTR,
  icon: '',
},
{
  label: '',
  value: 'xh',
  systemValue: xh,
  icon: '',
},
{
  label: '',
  value: 'zh',
  systemValue: zh,
  icon: '',
},
{
  label: '',
  value: 'zu',
  systemValue: zu,
  icon: '',
},
{
  label: '',
  value: 'bn',
  systemValue: bnIN,
  icon: '',
},
{
  label: '',
  value: 'ml',
  systemValue: mlIN,
  icon: '',
},
{
  label: '',
  value: 'or',
  systemValue: orIN,
  icon: '',
},
{
  label: '',
  value: 'pa',
  systemValue: paIN,
  icon: '',
},
{
  label: '',
  value: 'ur',
  systemValue: urIN,
  icon: '',
},
{
  label: '',
  value: 'st',
  systemValue: stZA,
  icon: '',
},
{
  label: '',
  value: 'nso',
  systemValue: nsoZA,
  icon: '',
},
{
  label: '',
  value: 'tn',
  systemValue: tnZA,
  icon: '',
},
{
  label: '',
  value: 'fil',
  systemValue: enPH,
  icon: '',
},
{
  label: '',
  value: 'gu',
  systemValue: enUS,
  icon: '',
},
{
  label: '',
  value: 'hi',
  systemValue: enUS,
  icon: '',
},
{
  label: '',
  value: 'kn',
  systemValue: enUS,
  icon: '',
},
{
  label: '',
  value: 'mr',
  systemValue: enUS,
  icon: '',
},
{
  label: '',
  value: 'ta',
  systemValue: enUS,
  icon: '',
},
{
  label: '',
  value: 'te',
  systemValue: enUS,
  icon: '',
},


  // {
  //   label: '中國傳統的）',
  //   value: 'cn',
  //   systemValue: zhCN,
  //   icon: '/assets/icons/flags/ic_flag_cn.svg',
  // },
  // {
  //   label: 'عربي',
  //   value: 'ar',
  //   systemValue: arSA,
  //   icon: '/assets/icons/flags/ic_flag_sa.svg',
  // }
];

//export const defaultLang = allLangs[0]; // English
export const defaultLang = allLangs.filter(lang => lang.value === "en-US")[0]; // English
